import { styled } from '@/stitches.config';

export const TableRowStyled = styled('tr', {
  'tbody &:hover': {
    backgroundColor: '$selectedRow',
  },
  variants: {
    clickable: {
      true: {
        'tbody &:hover': {
          cursor: 'pointer',
          outline: '1px solid $selectedRowOutline',
        },
      },
    },
  },
});
